// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: 'AIzaSyCDakRcwjTnhTWj9RrQgt-hzQpBk2mmz9w',
  authDomain: 'filmoteka-project-cdd1e.firebaseapp.com',
  databaseURL: 'https://filmoteka-project-cdd1e-default-rtdb.firebaseio.com',
  projectId: 'filmoteka-project-cdd1e',
  storageBucket: 'filmoteka-project-cdd1e.appspot.com',
  messagingSenderId: '518740651193',
  appId: '1:518740651193:web:7695d9b9aa198297cebf68',
};
